/* eslint-disable import/prefer-default-export */
export const errorsHandle = {
  emailInvalid: { code: '106', message: 'Digite um e-mail válido' },
};
